import { NotificationManager } from '../components/notifications';
import { ROUTES } from '../constants/app.constants';
import { history } from '../redux/store';

type NotificationType = 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

export const createNotification = (
  type: NotificationType,
  message: string,
  title?: string,
  className?: string,
  duration?: number,
  link?: string,
  linkMessage?: string,
) => {
  const cName = className || 'filled';
  let nManager = null;
  switch (type) {
    case 'primary':
      nManager = NotificationManager.primary(
        message,
        title || 'Primary Notification!',
        duration || 3000,
        null,
        null,
        cName,
      );
      break;
    case 'secondary':
      nManager = NotificationManager.secondary(
        message,
        title || 'Secondary Notification!',
        duration || 3000,
        null,
        null,
        cName,
      );
      break;
    case 'info':
      nManager = NotificationManager.info(message, title || 'Info!', duration || 3000, null, null, cName);
      break;
    case 'success':
      nManager = NotificationManager.success(message, title || 'Success!', duration || 3000, null, null, cName);
      break;
    case 'warning':
      nManager = NotificationManager.warning(message, title || 'Warning!', duration || 3000, null, null, cName);
      break;
    case 'error':
      nManager = NotificationManager.error(
        message,
        title || 'Error!',
        duration || 5000,
        null,
        null,
        cName,
        link,
        linkMessage,
      );
      break;
    default:
      nManager = NotificationManager.info(message);
      break;
  }

  return nManager;
};

export const InsighttNotification = (
  type: NotificationType,
  customMessage: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response?: any,
  title?: string,
  className?: string,
  duration?: number,
) => {
  const message = response?.data?.message || response?.message || customMessage || 'Unknown Error';
  const pathname = history.location.pathname;
  if (pathname.startsWith(ROUTES.auth.logout)) {
    return;
  }
  createNotification(type, message, title, className, duration);
};

export const InsighttNotificationWithLink = (
  type: NotificationType,
  customMessage: string,
  link: string,
  linkMessage: string,
) => {
  createNotification(type, customMessage, undefined, undefined, undefined, link, linkMessage);
};
